import React, { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { OneKlicksFileSDK } from '../SDK/OneKlicksFileSDK';
import { debugLog } from '../utils/debug';

// 🔹 Global cache object (keeps images in memory)
const imageCache = {};

const ImageShow = ({ image, width, height, style, url, type, redirect = "", className = "", onError }) => {
    const [imageUrl, setImageUrl] = useState(imageCache[image] || image);
    const [loading, setLoading] = useState(!imageCache[image]);
    const [hasError, setHasError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const WaterPlaceholder = () => (
        <div
            className="water-placeholder"
            style={{
                width: width === 0 ? '100%' : width,
                height: height === 0 ? '100%' : height,
                background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
                backgroundSize: '200% 100%',
                animation: 'waterWave 2s ease-in-out infinite',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                ...style
            }}
        >
            <style>{`
                @keyframes waterWave {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
            `}</style>
        </div>
    );

    useEffect(() => {
        const loadImage = async () => {
            setLoading(true);

            try {
                const isUrlValid = url && url !== "null" && url !== "" && typeof url === 'string' && !url.includes('private');
                const isImageValid = image && image !== "null" && image !== "";
                let finalUrl = '';

                if (isImageValid) {
                    // Always prefer resolving the image ID via SDK if available, as it handles permissions and latest URLs
                    if (imageCache[image]) {
                        finalUrl = imageCache[image];
                    } else {
                        const res = await OneKlicksFileSDK.getfile(image);
                        if (res && res.fileUrl) {
                            finalUrl = res.fileUrl;
                            imageCache[image] = finalUrl;
                        }
                    }
                }

                // If SDK resolution didn't yield a URL, fallback to the provided URL prop
                if (!finalUrl && isUrlValid) {
                    const isAbsolute = /^https?:\/\//i.test(url) || url.startsWith("data:") || url.startsWith("//");
                    if (isAbsolute) {
                        finalUrl = url;
                    } else {
                        const baseurl = process.env.REACT_APP_MODE === 'LIVE'
                            ? process.env.REACT_APP_API_BASE_LIVE_URL
                            : process.env.REACT_APP_API_BASE_URL;
                        const normalizedPath = url.startsWith("/") ? url : `/${url}`;
                        finalUrl = `${baseurl}${normalizedPath}`;
                    }
                }

                // Final check for placeholders
                if (!finalUrl || finalUrl === "" || finalUrl === "undefined") {
                    if (type === "doctor") {
                        finalUrl = "https://apis.oneklicks.com/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png";
                    } else if (type === "patient" || type === "user") {
                        finalUrl = "//css.meddylist.com//wp-content/uploads/1/2019/10/patient-placeholder.png";
                    }
                }

                console.log("finalUrl", finalUrl);
                if (!finalUrl || finalUrl === "" || finalUrl === "undefined") {
                    setImageUrl("not found");
                    setHasError(true);
                    if (onError) onError();
                } else {
                    setImageUrl(finalUrl);
                }
                setTimeout(() => setIsVisible(true), 100); // smooth fade-in
            } catch (error) {
                debugLog('Error loading image:', error);
                if (onError) onError();
                if (type === "doctor") {
                    console.log("finalUrl doctor error");
                    setImageUrl("https://apis.oneklicks.com/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png");
                } else if (type === "patient" || type === "user") {
                    setImageUrl("//css.meddylist.com//wp-content/uploads/1/2019/10/patient-placeholder.png");
                } else {
                    console.log("error");
                    setHasError(true);
                }
            } finally {
                setLoading(false);
            }
        };

        loadImage();
    }, [image, url, type]);

    const ImgTag = (
        <Image
            src={imageUrl}
            width={width === 0 ? '100%' : width}
            height={height === 0 ? '100%' : height}
            className={className}
            style={{
                ...style,
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.6s ease-in-out',
            }}
            onLoad={() => setIsVisible(true)}
            onError={() => {
                setHasError(true);
                if (onError) onError();
            }}
        />
    );

    return (
        <div
            className={className}
            title={imageUrl}
            style={{
                position: 'relative',
                width: width === 0 ? '100%' : width,
                height: height === 0 ? '100%' : height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {(loading || imageUrl === "" || imageUrl === "not found") && <WaterPlaceholder />}
            {imageUrl !== "not found" && (redirect
                ? <a href={redirect} target="_blank" rel="noopener noreferrer">{ImgTag}</a>
                : ImgTag)}
        </div>
    );
};

export default ImageShow;
